function initFloatingEmoji() {
  if (window.__mhFloatingEmojiInitialized) return;
  window.__mhFloatingEmojiInitialized = true;

  const EMOJIS = [
    '🍈','🌏','😎','🕶️','🌞','🍉','🍋','🎾','🌈','🍊',
    '🍎','🔥','💖','🍷','🎪','🎨','🍒','🦋','🍓','🍀',
    '🌝','🚀','🌛','⭐','🎲','🎠','🐸','🦄','🍹','🎡'
  ];
  const MOBILE_BREAKPOINT = 768;
  const EMOJI_SIZE_DESKTOP_RATIO = 0.08;
  const EMOJI_SIZE_MOBILE_RATIO = 0.2;
  const BUBBLE_RADIUS_MOBILE_SCALE = 0.7;
  const CHANGE_INTERVAL_MIN = 450;
  const CHANGE_INTERVAL_MAX = 1900;
  const CHANGE_BURST_CHANCE = 0.22;
  const CHANGE_BURST_MIN = 180;
  const CHANGE_BURST_MAX = 420;
  const SPEED = 3;
  const FRICTION = 0.98;
  const ROT_FRICTION = 0.97;
  const SPRING_K = 0.18;
  const SPRING_DAMPING = 0.72;
  const MAX_SPEED = 20;
  const DRAG_BUBBLE_INTERVAL = 40;
  const MAX_BUBBLES_DESKTOP = 520;
  const MAX_BUBBLES_MOBILE = 280;

  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;top:0;left:0;z-index:99999;pointer-events:none;user-select:none;';
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  let viewportWidth = 0;
  let viewportHeight = 0;
  let isMobile = false;
  let SIZE = 0;
  let hitRadius = 0;
  let bubbleScale = 1;
  let maxBubbles = MAX_BUBBLES_DESKTOP;
  let animationFrameId = 0;
  let isLoopRunning = false;
  let cursorState = '';

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getSize() {
    const ratio = isMobileViewport() ? EMOJI_SIZE_MOBILE_RATIO : EMOJI_SIZE_DESKTOP_RATIO;
    return Math.round(window.innerWidth * ratio);
  }

  function resize() {
    viewportWidth = window.innerWidth;
    viewportHeight = window.innerHeight;
    isMobile = isMobileViewport();
    SIZE = getSize();
    hitRadius = SIZE * 0.45;
    bubbleScale = isMobile ? BUBBLE_RADIUS_MOBILE_SCALE : 1;
    maxBubbles = isMobile ? MAX_BUBBLES_MOBILE : MAX_BUBBLES_DESKTOP;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.style.width = viewportWidth + 'px';
    canvas.style.height = viewportHeight + 'px';
    canvas.width = Math.round(viewportWidth * dpr);
    canvas.height = Math.round(viewportHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  const initAngle = Math.random() * Math.PI * 2;
  let x = Math.random() * (viewportWidth - SIZE * 2) + SIZE;
  let y = Math.random() * (viewportHeight - SIZE * 2) + SIZE;
  let vx = Math.cos(initAngle) * SPEED;
  let vy = Math.sin(initAngle) * SPEED;
  let rotation = 0;
  let angularVelocity = 0;
  let currentEmoji = EMOJIS[0];

  let springX = x;
  let springY = y;
  let springVx = 0;
  let springVy = 0;

  let mouseX = -9999;
  let mouseY = -9999;
  let isDragging = false;
  let dragTargetX = x;
  let dragTargetY = y;
  let prevAngle = 0;
  let lastX = 0;
  let lastY = 0;
  let lastTime = 0;
  let throwVx = 0;
  let throwVy = 0;
  let throwAngularVelocity = 0;
  let lastDragBubbleTime = 0;

  const bubbles = [];

  function trimBubbles() {
    const overflow = bubbles.length - maxBubbles;
    if (overflow > 0) bubbles.splice(0, overflow);
  }

  function spawnDragBubbles(bx, by) {
    const count = 2 + Math.floor(Math.random() * 3);
    const jitter = hitRadius * 0.8;
    for (let i = 0; i < count; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 0.3 + Math.random() * 1.2;
      const r = (0.5 + Math.random() * 1.8) * bubbleScale;
      const isWhite = Math.random() < 0.3;
      const hue = 118 + Math.random() * 16;
      const sat = 70 + Math.random() * 25;
      const lgt = 33 + Math.random() * 38;

      bubbles.push({
        x: bx + (Math.random() - 0.5) * jitter,
        y: by + (Math.random() - 0.5) * jitter,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 0.5,
        r: r,
        life: 0.5 + Math.random() * 0.4,
        decay: 0.014 + Math.random() * 0.018,
        wobble: Math.random() * Math.PI * 2,
        wobbleSpeed: 0.04 + Math.random() * 0.06,
        wobbleAmp: 0.1 + Math.random() * 0.3,
        isWhite: isWhite,
        h: hue, s: sat, l: lgt,
        buoyancy: 0.025 + Math.random() * 0.04,
        drag: 0.97 + Math.random() * 0.015,
      });
    }
    trimBubbles();
  }

  function spawnBubbles(bx, by, wallDir) {
    const count = (isMobile ? 12 : 20) + Math.floor(Math.random() * (isMobile ? 8 : 12));
    const jitter = hitRadius * 1.2;
    for (let i = 0; i < count; i++) {
      let baseAngle;
      if (wallDir === 'left')       baseAngle = 0;
      else if (wallDir === 'right') baseAngle = Math.PI;
      else if (wallDir === 'top')   baseAngle = Math.PI * 0.5;
      else                          baseAngle = -Math.PI * 0.5;

      const spread = (Math.random() - 0.5) * Math.PI * 1.4;
      const angle = baseAngle + spread;
      const speed = 0.4 + Math.random() * 3.2;
      const r = (0.6 + Math.random() * 2.2) * bubbleScale;
      const isWhite = Math.random() < 0.25;
      const hue = 118 + Math.random() * 16;
      const sat = 75 + Math.random() * 25;
      const lgt = 32 + Math.random() * 38;

      bubbles.push({
        x: bx + (Math.random() - 0.5) * jitter,
        y: by + (Math.random() - 0.5) * jitter,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        r: r,
        life: 0.85 + Math.random() * 0.15,
        decay: 0.01 + Math.random() * 0.018,
        wobble: Math.random() * Math.PI * 2,
        wobbleSpeed: 0.035 + Math.random() * 0.065,
        wobbleAmp: 0.1 + Math.random() * 0.35,
        isWhite: isWhite,
        h: hue, s: sat, l: lgt,
        buoyancy: 0.03 + Math.random() * 0.06,
        drag: 0.97 + Math.random() * 0.018,
      });
    }
    trimBubbles();
  }

  function spawnAmbientBubbles() {
    const count = (isMobile ? 24 : 60) + Math.floor(Math.random() * (isMobile ? 18 : 40));
    for (let i = 0; i < count; i++) {
      const r = (0.4 + Math.random() * 1.6) * bubbleScale;
      const isWhite = Math.random() < 0.35;
      const hue = 118 + Math.random() * 16;
      const sat = 60 + Math.random() * 30;
      const lgt = 35 + Math.random() * 40;

      bubbles.push({
        x: Math.random() * viewportWidth,
        y: Math.random() * viewportHeight,
        vx: (Math.random() - 0.5) * 0.4,
        vy: -(0.3 + Math.random() * 1.2),
        r: r,
        life: 0.3 + Math.random() * 0.55,
        decay: 0.006 + Math.random() * 0.01,
        wobble: Math.random() * Math.PI * 2,
        wobbleSpeed: 0.025 + Math.random() * 0.05,
        wobbleAmp: 0.08 + Math.random() * 0.25,
        isWhite: isWhite,
        h: hue, s: sat, l: lgt,
        buoyancy: 0.015 + Math.random() * 0.03,
        drag: 0.985 + Math.random() * 0.012,
      });
    }
    trimBubbles();
  }

  function spawnRisingBubbles() {
    const columns = (isMobile ? 7 : 12) + Math.floor(Math.random() * (isMobile ? 4 : 8));
    const countPerColumn = (isMobile ? 3 : 6) + Math.floor(Math.random() * (isMobile ? 3 : 6));
    for (let c = 0; c < columns; c++) {
      const colX = (viewportWidth / columns) * c + (viewportWidth / columns) * Math.random();
      for (let i = 0; i < countPerColumn; i++) {
        const r = (0.5 + Math.random() * 2.5) * bubbleScale;
        const isWhite = Math.random() < 0.3;
        const hue = 118 + Math.random() * 16;
        const sat = 70 + Math.random() * 25;
        const lgt = 33 + Math.random() * 38;
        const delay = Math.random() * 0.6;

        bubbles.push({
          x: colX + (Math.random() - 0.5) * 20,
          y: viewportHeight + Math.random() * 40,
          vx: (Math.random() - 0.5) * 0.3,
          vy: -(0.8 + Math.random() * 2.0),
          r: r,
          life: (0.5 + Math.random() * 0.5) - delay,
          decay: 0.004 + Math.random() * 0.008,
          wobble: Math.random() * Math.PI * 2,
          wobbleSpeed: 0.03 + Math.random() * 0.05,
          wobbleAmp: 0.12 + Math.random() * 0.35,
          isWhite: isWhite,
          h: hue, s: sat, l: lgt,
          buoyancy: 0.04 + Math.random() * 0.06,
          drag: 0.99 + Math.random() * 0.008,
        });
      }
    }
    trimBubbles();
  }

  function updateBubbles() {
    for (let i = bubbles.length - 1; i >= 0; i--) {
      const b = bubbles[i];
      if (b.life <= 0) { bubbles.splice(i, 1); continue; }
      b.wobble += b.wobbleSpeed;
      b.x += b.vx + Math.sin(b.wobble) * b.wobbleAmp;
      b.y += b.vy;
      b.vy -= b.buoyancy;
      b.vx *= b.drag;
      b.vy *= b.drag;
      b.life -= b.decay;
    }
  }

  function drawBubbles() {
    ctx.save();
    for (let i = 0; i < bubbles.length; i++) {
      const b = bubbles[i];
      const alpha = Math.max(0, b.life);
      const r = Math.max(0.5, b.r);

      if (b.isWhite) {
        ctx.beginPath();
        ctx.arc(b.x, b.y, r, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(255,255,255,' + (alpha * 0.45) + ')';
        ctx.lineWidth = 0.6;
        ctx.stroke();
        const g1 = ctx.createRadialGradient(b.x - r * 0.3, b.y - r * 0.3, r * 0.05, b.x, b.y, r);
        g1.addColorStop(0, 'rgba(255,255,255,' + (alpha * 0.45) + ')');
        g1.addColorStop(0.5, 'rgba(255,255,255,' + (alpha * 0.1) + ')');
        g1.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g1;
        ctx.fill();
      } else {
        ctx.beginPath();
        ctx.arc(b.x, b.y, r, 0, Math.PI * 2);
        ctx.strokeStyle = 'hsla(' + b.h + ',' + b.s + '%,' + b.l + '%,' + (alpha * 0.65) + ')';
        ctx.lineWidth = 0.65;
        ctx.stroke();
        const g2 = ctx.createRadialGradient(b.x - r * 0.28, b.y - r * 0.28, r * 0.04, b.x, b.y, r);
        g2.addColorStop(0, 'hsla(' + b.h + ',' + b.s + '%,' + (b.l + 18) + '%,' + (alpha * 0.38) + ')');
        g2.addColorStop(0.55, 'hsla(' + b.h + ',' + b.s + '%,' + b.l + '%,' + (alpha * 0.15) + ')');
        g2.addColorStop(1, 'hsla(' + b.h + ',' + b.s + '%,' + b.l + '%,0)');
        ctx.fillStyle = g2;
        ctx.fill();
        ctx.beginPath();
        ctx.arc(b.x - r * 0.25, b.y - r * 0.27, r * 0.18, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,' + (alpha * 0.6) + ')';
        ctx.fill();
      }
    }
    ctx.restore();
  }

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function pickNextChangeDelay() {
    if (Math.random() < CHANGE_BURST_CHANCE) {
      return randomInt(CHANGE_BURST_MIN, CHANGE_BURST_MAX);
    }
    return randomInt(CHANGE_INTERVAL_MIN, CHANGE_INTERVAL_MAX);
  }

  function pickNextEmoji(current) {
    if (EMOJIS.length <= 1) return EMOJIS[0];
    let next = current;
    while (next === current) {
      next = EMOJIS[Math.floor(Math.random() * EMOJIS.length)];
    }
    return next;
  }

  function scheduleNextEmojiChange() {
    setTimeout(function () {
      if (!isDragging) {
        currentEmoji = pickNextEmoji(currentEmoji);
      }
      scheduleNextEmojiChange();
    }, pickNextChangeDelay());
  }

  scheduleNextEmojiChange();

  function isHit(px, py) {
    const dx = px - x;
    const dy = py - y;
    return (dx * dx + dy * dy) <= (hitRadius * hitRadius);
  }

  function setCursor(nextCursorState) {
    if (cursorState === nextCursorState) return;
    cursorState = nextCursorState;
    document.body.style.cursor = nextCursorState;
  }

  function updateCursor() {
    if (isDragging) {
      setCursor('grabbing');
    } else if (isHit(mouseX, mouseY)) {
      setCursor('grab');
    } else {
      setCursor('');
    }
  }

  function resolveWalls() {
    const r = hitRadius;
    let wallDir = null;

    if (x - r < 0) {
      x = r; vx = Math.abs(vx);
      wallDir = 'left';
    } else if (x + r > viewportWidth) {
      x = viewportWidth - r; vx = -Math.abs(vx);
      wallDir = 'right';
    }

    if (y - r < 0) {
      y = r; vy = Math.abs(vy);
      wallDir = wallDir || 'top';
    } else if (y + r > viewportHeight) {
      y = viewportHeight - r; vy = -Math.abs(vy);
      wallDir = wallDir || 'bottom';
    }

    if (wallDir) {
      angularVelocity = (Math.random() - 0.5) * 0.15;
      spawnBubbles(x, y, wallDir);
      spawnAmbientBubbles();
      spawnRisingBubbles();
    }
  }

  function onMouseMove(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (!isDragging) {
      updateCursor();
      return;
    }
    const now = performance.now();
    const dt = now - lastTime;
    dragTargetX = e.clientX;
    dragTargetY = e.clientY;
    const curAngle = Math.atan2(e.clientY - springY, e.clientX - springX);
    let dAngle = curAngle - prevAngle;
    if (dAngle > Math.PI) dAngle -= Math.PI * 2;
    if (dAngle < -Math.PI) dAngle += Math.PI * 2;
    if (dt > 0) {
      throwVx = (e.clientX - lastX) / dt * 16;
      throwVy = (e.clientY - lastY) / dt * 16;
      throwAngularVelocity = dAngle / dt * 16;
    }
    prevAngle = curAngle;
    lastX = e.clientX;
    lastY = e.clientY;
    lastTime = now;

    if (now - lastDragBubbleTime > DRAG_BUBBLE_INTERVAL) {
      spawnDragBubbles(springX, springY);
      lastDragBubbleTime = now;
    }
  }

  function onTouchMove(e) {
    if (!isDragging) return;
    const touch = e.touches[0];
    const now = performance.now();
    const dt = now - lastTime;
    dragTargetX = touch.clientX;
    dragTargetY = touch.clientY;
    const curAngle = Math.atan2(touch.clientY - springY, touch.clientX - springX);
    let dAngle = curAngle - prevAngle;
    if (dAngle > Math.PI) dAngle -= Math.PI * 2;
    if (dAngle < -Math.PI) dAngle += Math.PI * 2;
    if (dt > 0) {
      throwVx = (touch.clientX - lastX) / dt * 16;
      throwVy = (touch.clientY - lastY) / dt * 16;
      throwAngularVelocity = dAngle / dt * 16;
    }
    prevAngle = curAngle;
    lastX = touch.clientX;
    lastY = touch.clientY;
    lastTime = now;

    if (now - lastDragBubbleTime > DRAG_BUBBLE_INTERVAL) {
      spawnDragBubbles(springX, springY);
      lastDragBubbleTime = now;
    }

    e.preventDefault();
  }

  function onPointerDown(e) {
    const px = e.clientX !== undefined ? e.clientX : e.touches[0].clientX;
    const py = e.clientY !== undefined ? e.clientY : e.touches[0].clientY;
    if (!isHit(px, py)) return;
    isDragging = true;
    dragTargetX = px;
    dragTargetY = py;
    springX = x;
    springY = y;
    springVx = 0;
    springVy = 0;
    prevAngle = Math.atan2(py - y, px - x);
    lastX = px;
    lastY = py;
    lastTime = performance.now();
    lastDragBubbleTime = 0;
    throwVx = 0;
    throwVy = 0;
    throwAngularVelocity = 0;
    canvas.style.pointerEvents = 'auto';
    setCursor('grabbing');
    e.preventDefault();
  }

  function onPointerUp() {
    if (!isDragging) return;
    isDragging = false;
    canvas.style.pointerEvents = 'none';

    x = springX;
    y = springY;

    const rawSpeed = Math.sqrt(throwVx * throwVx + throwVy * throwVy);
    if (rawSpeed > 0.5) {
      const capped = Math.min(rawSpeed, MAX_SPEED);
      vx = (throwVx / rawSpeed) * capped;
      vy = (throwVy / rawSpeed) * capped;
    } else {
      const angle = Math.random() * Math.PI * 2;
      vx = Math.cos(angle) * SPEED;
      vy = Math.sin(angle) * SPEED;
    }

    resolveWalls();

    angularVelocity = Math.max(-0.3, Math.min(0.3, throwAngularVelocity));
    updateCursor();
  }

  document.addEventListener('mousedown', onPointerDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onPointerUp);
  document.addEventListener('touchstart', onPointerDown, { passive: false });
  document.addEventListener('touchmove', onTouchMove, { passive: false });
  document.addEventListener('touchend', onPointerUp);

  function loop() {
    if (!isLoopRunning) return;
    ctx.clearRect(0, 0, viewportWidth, viewportHeight);

    if (isDragging) {
      const fx = (dragTargetX - springX) * SPRING_K;
      const fy = (dragTargetY - springY) * SPRING_K;
      springVx = (springVx + fx) * SPRING_DAMPING;
      springVy = (springVy + fy) * SPRING_DAMPING;
      springX += springVx;
      springY += springVy;

      const dx = springX - dragTargetX;
      const dy = springY - dragTargetY;
      const stretchAngle = Math.atan2(dy, dx);
      const stretchDist = Math.sqrt(dx * dx + dy * dy);
      const rotDelta = stretchDist * 0.003;
      angularVelocity = rotDelta * (Math.sin(stretchAngle - rotation) > 0 ? 1 : -1);
      rotation += angularVelocity;
      x = springX;
      y = springY;
    } else {
      x += vx;
      y += vy;
      rotation += angularVelocity;
      angularVelocity *= ROT_FRICTION;
      vx *= FRICTION;
      vy *= FRICTION;

      const minSpeed = SPEED * 0.8;
      const currentSpeed = Math.sqrt(vx * vx + vy * vy);
      if (currentSpeed > 0 && currentSpeed < minSpeed) {
        const scale = minSpeed / currentSpeed;
        vx *= scale;
        vy *= scale;
      }

      resolveWalls();
    }

    updateBubbles();
    drawBubbles();
    ctx.save();
    ctx.font = SIZE + 'px serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.fillText(currentEmoji, 0, 0);
    ctx.restore();

    animationFrameId = requestAnimationFrame(loop);
  }

  function startLoop() {
    if (isLoopRunning) return;
    isLoopRunning = true;
    loop();
  }

  function stopLoop() {
    isLoopRunning = false;
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = 0;
    }
  }

  function onVisibilityChange() {
    if (document.hidden) stopLoop();
    else startLoop();
  }

  document.addEventListener('visibilitychange', onVisibilityChange);
  startLoop();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFloatingEmoji, { once: true });
} else {
  initFloatingEmoji();
}
